export default "__VITE_ASSET__BezH3cz0__"